//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import mapUtil from "@/javascript/mapUtil";
// import payPublic from '@/res/javascript/payPublic'
import goMini from "@/components/hznz-components/go-mini/index.vue";
import util from "@/javascript/util";
import goBack from '@/components/public-components/goBack/index.vue'

export default {
  components: {
    goMini,
    goBack
  },
  data () {
    return {
      minHeight: 0,
      placeData: "",
      placeData1: "",
      location: {},
      typeQuery: [
        { name: "医院", key: "127020" },
        { name: "派出所", key: "127023" },
      ],
      kind: 0,
      typedatas: "",
      kindList: [],
      kindDatas: [],
      center: [],
      macLnt: "",
      macLat: "",
      minDistance1: "",
      minDistance2: "",
      isWeiXin: util.isWeiXin(),
      formattedAddress: "",
    };
  },
 
  mounted () {
    const _this = this;
    document.title = "一键救援";
    _this.minHeight = document.documentElement.clientHeight;

    /**
     * 微信签名分享
     */
    if (util.isWeiXin()) {
        const shareData = typeof (shareData) === 'undefined' ? {
          title: this.PAGE_TITLE + "导览",
          desc: '圣湖之光，大景海晏，海晏欢迎您~~',
          imgUrl: window.location.origin + '/static/-img/banner_img.png',
          link: window.location.href
        } : shareData;
        this.$http.get('/api/wtcp-support/weixin/createJsapiSignature?url=' + encodeURIComponent(window.location.href) + '&appId=' + this.WX_APPID).then((response) => {
          
        util.initWxConfig(response.data.data, shareData);
        
        _this.getLoca();
      }) 

    } else {
        _this.getLoca();
    };
  },
  methods: {
    getLoca () {
      mapUtil.locate(
        (data) => {
          this.macLnt = data.position.lng;
          this.macLat = data.position.lat;
          this.formattedAddress = data.formattedAddress;
          this.center = [data.location.lng, data.location.lat];
          this.placeData = data;
          this.$nextTick(function () {
            this.dataList();
          });
        },
        (data) => {
          this.macLnt = data.position.lng;
          this.macLat = data.position.lat;
          this.formattedAddress = data.formattedAddress;
          this.center = [data.location.lng, data.location.lat];
          this.placeData = data;
          this.$nextTick(function () {
            this.dataList();
          });
        }
      );
    },
    callPhone (tel) {
      // payPublic.callPhone(tel)
    },
    dataList () {
      this.kindList = [];
      if (this.placeData) {
        for (let i = 0; i < this.typeQuery.length; i++) {
          this.$http
            .get(
              "https://restapi.amap.com/v3/place/around?key=a925182b5f675e9eaf05f8edf6c1b5bc&location=" +
              this.macLnt +
              "," +
              this.macLat +
              "&keywords=" +
              this.typeQuery[i].name +
              "&offset=5&page=1"
            )
            .then((response) => {
              this.kindDatas = response.data.pois;
              if (i == 0) {
                this.kindDatas.map((item) => {
                  (item.kind = "127020"),
                    (item.location = item.location.split(","));
                });
                this.minDistance1 = this.kindDatas[0];
              } else {
                this.kindDatas.map((item) => {
                  item.kind = "127023";
                  item.location = item.location.split(",");
                });
                this.minDistance2 = this.kindDatas[0];
              }
              this.placeData1 = this.kindDatas[0].pname + ',' + this.kindDatas[0].cityname + ',' + this.kindDatas[0].adname + ',' + this.kindDatas[0].address
            })
            .then(() => {
              this.kindList = [...this.kindList, ...this.kindDatas];
              this.init();
            });
        }
      }
    },
    init () {
      const _this = this;
      const map = new AMap.Map("mapBox", {
        zoomEnable: false,
        dragEnable: false,
        zoom: 13,
        center: _this.center,
        // mapStyle: "amap://styles/whitesmoke"
      });
      var nowIcon = new AMap.Icon({
        size: new AMap.Size(20, 33), // 图标尺寸
        image: require("../../../assets/hznz-img/map-mylocation.png"), // 图标的取图地址
        imageSize: new AMap.Size(20, 33), // 图标所用图片大小
      });
      // 显示当前位置
      var nowMarker = new AMap.Marker({
        icon: nowIcon,
        position: new AMap.LngLat(_this.macLnt, _this.macLat),
      });
      map.add(nowMarker);
      let markers = [];
      let atlas = {
        127020: require("@/assets/hznz-img/map-yd-icon.png"),
        127023: require("@/assets/hznz-img/map-za-icon.png"),
      };
      for (let i = 0; i < _this.kindList.length; i += 1) {
        let icon = new AMap.Icon({
          size: new AMap.Size(22, 22),
          imageSize: new AMap.Size(22, 22),
          image: atlas[_this.kindList[i].kind],
        });
        let marker = new AMap.Marker({
          icon: icon,
          position: [
            _this.kindList[i].location[0],
            _this.kindList[i].location[1],
          ],
          map: map,
        });
        markers.push(marker);
      }

      map.on("click", function (e) {
        _this.$router.push({ path: "/peripheral/0" });
      });
    },
    gpsJump (itemitude) {
      const _this = this
        mapUtil.locate((data) => {
          window.location.href = 'https://map.qq.com/nav/drive#routes/page?eword=' + itemitude.name + '&noback=&referer=groupActivity_myapp&ch=mc_h5marker&start=' + data.position.lng + ',' + data.position.lat + '&dest=' + itemitude.location[0] + ',' + itemitude.location[1] + '&sword=我的位置'
        }, (data) => {
          window.location.href = 'https://map.qq.com/nav/drive#routes/page?eword=' + itemitude.name + '&noback=&referer=groupActivity_myapp&ch=mc_h5marker&start=' + data.position.lng + ',' + data.position.lat + '&dest=' + itemitude.location[0] + ',' + itemitude.location[1] + '&sword=我的位置'
        })
      
    }
  }
}
